import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateVehicleRoadTaxDto } from '../../dtos/create-vehicle-road-tax.dto';
import { UpdateVehicleRoadTaxDto } from '../../dtos/update-vehicle-road-tax.dto';
import { createVehicleRoadTaxSchema } from '../schemas/create-vehicle-road-tax.schema';
import { updateVehicleRoadTaxSchema } from '../schemas/update-vehicle-road-tax.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateVehicleRoadTaxDto | UpdateVehicleRoadTaxDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// Determine if it's an update or create operation by checking for 'id'
	if ('id' in record && record.id) {
		// Validate against updateVehicleRoadTaxSchema if 'id' is present
		validationResult = updateVehicleRoadTaxSchema().validate(record, {
			abortEarly,
		});
	} else {
		// Validate against createVehicleRoadTaxSchema if 'id' is not present
		validationResult = createVehicleRoadTaxSchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
